import { render, staticRenderFns } from "./MdtVideo.vue?vue&type=template&id=dd347b04&scoped=true"
import script from "./MdtVideo.vue?vue&type=script&lang=js"
export * from "./MdtVideo.vue?vue&type=script&lang=js"
import style0 from "./MdtVideo.vue?vue&type=style&index=0&id=dd347b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd347b04",
  null
  
)

export default component.exports